import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { getDistanceUnit, getOfferBasedLereState } from 'selectors/recommendations'
import CustomersViewedAndBooked, { Props as CustomersViewedAndBookedProps } from '../CustomersViewedAndBooked/CustomersViewedAndBooked'
import uuidV4 from 'lib/string/uuidV4Utils'
import TrackingContext, { TrackingProps } from 'contexts/trackingContext'
import { getListName } from 'analytics/enhanced-ecommerce'
import useLoadOfferBasedLereRecommendations from 'components/Recommendations/YouMayAlsoLike/Offer/hooks/useLoadOfferBasedLereRecommendations'

interface Props extends CustomersViewedAndBookedProps {
  seedOffer: App.Offer | App.BedbankOffer;
  pageSource: string;
}

const TRACKING_EVENT_CATEGORY = 'LERE'
const TRACKING_EVENT_NAME = 'Customer Viewed And Booked Carousel'

function OfferCustomerViewedAndBooked({ pageSource, ...passOnProps }: Props) {
  const {
    seedOffer,
    filters,
    lereVersion,
  } = passOnProps

  const { checkIn, checkOut } = filters ?? {}

  useLoadOfferBasedLereRecommendations(seedOffer.id, true, checkIn, checkOut)

  const customerViewedAndBookedTracking = useMemo<TrackingProps>(() => ({
    category: TRACKING_EVENT_CATEGORY,
    label: getListName(TRACKING_EVENT_CATEGORY, pageSource, TRACKING_EVENT_NAME),
    listId: uuidV4(),
    listName: getListName(TRACKING_EVENT_CATEGORY, pageSource, TRACKING_EVENT_NAME),
    ...(lereVersion ? { lere: { version: lereVersion } } : {}),
  }), [lereVersion, pageSource])

  const customerViewedAndBookedProps: CustomersViewedAndBookedProps = {
    ...passOnProps,
  }

  return (
    <TrackingContext.Provider value={customerViewedAndBookedTracking}>
      <CustomersViewedAndBooked
        {...customerViewedAndBookedProps}
      />
    </TrackingContext.Provider>
  )
}

function mapState(state: App.State, ownProps: Partial<Props>) {
  const { seedOffer } = ownProps
  const offerBasedLereState = getOfferBasedLereState(
    state,
    seedOffer!,
  )

  return {
    offerIds: offerBasedLereState.offerIds,
    currency: state.geo.currentCurrency,
    distanceUnit: getDistanceUnit(state),
    loadingState: offerBasedLereState.loadingState,
    loadingError: offerBasedLereState.loadingError,
    lereVersion: offerBasedLereState.lereVersion,
    hasEnoughRecommendationsToDisplay: offerBasedLereState.hasEnoughRecommendationsToDisplay,
  }
}

export default connect(mapState)(OfferCustomerViewedAndBooked)
